import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import appInfo from "@common/appInfo";
import { makeNetworkVolumeConfigSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = EntityRef & {
  cycleEndDate: string;
  currencyCode: string | null | undefined;
  itemId: string;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const configSelector = makeNetworkVolumeConfigSelector();

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      apiInfo: apiInfoSelector(state, { id: props.itemId, source: props.source }),
      config: configSelector(state, { id: props.itemId, source: props.source }),
      cycleEndDate: props.cycleEndDate,
      userId: appInfo.user!.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onClick: () => {} //dispatch(openModuleSettingsModal(props.itemId, true))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
